<template>
  <section class="section-four">
    <div class="section-four--wrapper">
      <div class="section-title">
        <div class="section-top-title">
          <span class="title">Concorrenti</span>
        </div>
        <span class="text-two"> Distribuzione della {{ infocar.nome }} sul mercato </span>
      </div>
      <div class="dropdownSelect">
        <custom-select
          :options="selectOptions"
          v-model="currentSelection"
          placeholder="Seleziona un'opzione"
          :name="'typeSelection'"
          :isOpen="openDropdown === 0"
          @toggle="handleToggle(0)"
        ></custom-select>
      </div>
      <div id="kmChart" class="section-four--bottom" v-show="currentSelection === 'pricePerKm'">
        <div class="qrt-xy-chart">
          <div style="width: 100%; height: 100%; position: relative;">
            <bubble-chart
              ref="kmBubbleChart"
              :chart-data="bubbleChartDataKm"
              :chart-options="chartOptionsKm"
            ></bubble-chart>
          </div>
        </div>
      </div>
      <div id="yearChart" class="section-four--bottom" v-show="currentSelection === 'pricePerYear'">
        <div class="qrt-xy-chart2">
          <div style="width: 100%; height: 100%; position: relative;">
            <bubble-chart
              ref="yearBubbleChart"
              :chart-data="bubbleChartDataYears"
              :chart-options="chartOptionsYears"
            ></bubble-chart>
          </div>
        </div>
      </div>
      <div class="section-four--footerText">
        Esplora i singoli punti del grafico per ulteriori informazioni
      </div>
    </div>
  </section>
</template>

<script>
import BubbleChart from './BubbleChart';
import CustomSelect from './CustomSelect';

export default {
  name: 'LivemarketDataCompetitors',
  props: {
    infocar: {
      type: Object,
      required: true,
    },
    competitors: {
      type: Object,
      required: true,
    },
  },
  components: {
    BubbleChart,
    CustomSelect,
  },
  computed: {
    bubbleChartDataKm() {
      const carData = {
        x: this.competitors.auto.chilometri,
        y: this.competitors.auto.prezzo,
        r: 13,
        isCarPoint: true,
        info: null,
      };

      const pointData = (this.competitors.points || []).map(point => ({
        x: point.ascisse.chilometri,
        y: point.ordinate.prezzoMercato,
        r: 7,
        isCarPoint: false,
        info: point.info,
      }));
      const combinedData = [...pointData, carData];

      return {
        datasets: [
          {
            data: combinedData,
            backgroundColor: combinedData.map(p => (p.isCarPoint ? '#d20a11' : '#efefef')),
            hoverBackgroundColor: combinedData.map(p => (p.isCarPoint ? '#d20a11' : '#d0d0d0')),
          },
        ],
      };
    },
    bubbleChartDataYears() {
      const sortedPoints = [...(this.competitors.points || [])].sort((a, b) => {
        const dateA = new Date(a.ascisse.immatricolazione + '-01');
        const dateB = new Date(b.ascisse.immatricolazione + '-01');
        return dateA - dateB;
      });

      const carData = {
        x: this.formatDate(this.competitors.auto.anno_mese),
        y: this.competitors.auto.prezzo,
        r: 13,
        isCarPoint: true,
        info: null,
      };

      const pointData = sortedPoints.map(point => ({
        x: this.formatDate(point.ascisse.immatricolazione),
        y: point.ordinate.prezzoMercato,
        r: 7,
        isCarPoint: false,
        info: point.info,
      }));

      const combinedData = [...pointData, carData];

      return {
        datasets: [
          {
            data: combinedData,
            backgroundColor: combinedData.map(p => (p.isCarPoint ? '#d20a11' : '#efefef')),
            hoverBackgroundColor: combinedData.map(p => (p.isCarPoint ? '#d20a11' : '#d0d0d0')),
          },
        ],
      };
    },
    chartOptionsKm() {
      return this.buildChartOptions('Chilometri', ctx => this.customTooltipLabelKm(ctx), false);
    },
    chartOptionsYears() {
      return this.buildChartOptions('Data', ctx => this.customTooltipLabelYears(ctx), true);
    },
  },
  data() {
    return {
      selectOptions: [
        { value: 'pricePerKm', text: 'Mostra Prezzo / km' },
        { value: 'pricePerYear', text: 'Mostra Prezzo / anno' },
      ],
      currentSelection: 'pricePerKm',
      openDropdown: null,
    };
  },
  watch: {
    currentSelection() {
      this.$nextTick(() => {
        const chartRef =
          this.currentSelection === 'pricePerKm'
            ? this.$refs.kmBubbleChart
            : this.$refs.yearBubbleChart;
        if (chartRef && typeof chartRef.resize === 'function') {
          chartRef.resize();
        }
      });
    },
  },
  methods: {
    buildChartOptions(xTitle, tooltipCallback, categoryScale) {
      const xScale = {
        title: {
          display: true,
          text: xTitle,
          color: 'black',
          font: {
            size: 16,
            weight: 'bold',
          },
        },
      };
      if (categoryScale) {
        xScale.type = 'category';
      }

      return {
        responsive: true,
        maintainAspectRatio: true,
        interaction: {
          mode: 'nearest',
          intersect: true,
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            callbacks: {
              title: function() {
                return '';
              },
              label: function(context) {
                return tooltipCallback(context);
              },
            },
          },
        },
        elements: {
          point: {
            hitRadius: 10,
          },
        },
        scales: {
          x: xScale,
          y: {
            title: {
              display: true,
              text: 'Prezzo',
              color: 'black',
              font: {
                size: 16,
                weight: 'bold',
              },
            },
          },
        },
      };
    },
    handleToggle(index) {
      if (this.openDropdown === index) {
        this.openDropdown = null;
      } else {
        this.openDropdown = index;
      }
    },
    formatDate(dateStr) {
      const months = [
        'Gen',
        'Feb',
        'Mar',
        'Apr',
        'Mag',
        'Giu',
        'Lug',
        'Ago',
        'Set',
        'Ott',
        'Nov',
        'Dic',
      ];
      const [year, month] = dateStr.split('-');
      return `${months[parseInt(month) - 1]} ${year}`;
    },
    formatTooltipNumber(value) {
      const n = Number(value);
      if (Number.isNaN(n)) {
        return value != null ? value : '';
      }
      return n.toLocaleString('it-IT');
    },
    competitorTooltipLines(dataPoint, axisLabel) {
      const info = dataPoint.info || {};
      const lines = [
        `${axisLabel}: ${this.formatTooltipNumber(dataPoint.x)}${axisLabel === 'Chilometri' ? ' km' : ''}`,
        `Prezzo Mercato: ${this.formatTooltipNumber(dataPoint.y)}€`,
      ];
      if (info.differenzaKm !== undefined && info.differenzaKm !== null) {
        lines.push(`Differenza Km: ${this.formatTooltipNumber(info.differenzaKm)} km`);
      }
      return lines;
    },
    customTooltipLabelKm(context) {
      const dataPoint = context.raw || {};
      if (dataPoint.isCarPoint) {
        return `La tua Moto: ${this.formatTooltipNumber(dataPoint.x)} km - Prezzo: ${this.formatTooltipNumber(dataPoint.y)}€`;
      }
      return this.competitorTooltipLines(dataPoint, 'Chilometri');
    },
    customTooltipLabelYears(context) {
      const dataPoint = context.raw || {};
      if (dataPoint.isCarPoint) {
        return `La tua Moto: ${dataPoint.x} - Prezzo: ${this.formatTooltipNumber(dataPoint.y)}€`;
      }
      return this.competitorTooltipLines(dataPoint, 'Anno');
    },
  },
};
</script>

<style scoped>
.section-four {
  padding: 40px 0px 24px;
  border-bottom: 2px solid #e4e4e4;
  margin: 0px 100px;
}
.section-four--wrapper {
  max-width: 830px;
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
}
.section-title {
  display: flex;
  flex-direction: column;
}
.section-top-title {
  display: flex;
  justify-content: space-between;
}
.section-top-title .title {
  color: #d20a11;
  font-size: 21px;
  line-height: 28px;
  font-weight: bold;
}
.text-two {
  font-size: 0.875rem;
  line-height: 18px;
  margin-top: 5px;
}
.dropdownSelect {
  position: relative;
  display: flex;
  flex-direction: column;
  align-self: center;
  margin: 28px 0px 10px;
}

.section-four--footerText {
  color: #aaaaaa;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  margin-top: 5px;
}

@media (max-width: 992px) {
  .section-four {
    padding: 44px 20px 42px;
    margin: 0px 40px;
  }
}

@media (max-width: 600px) {
  .section-four {
    padding: 32px 0px 15px;
    margin: 0px 17px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/LivemarketDataCompetitors.vue